import type {ReactNode} from 'react'
import {useViewerRoles} from '../shared/use-viewer-roles'
import type {ForYouViewerRoles} from '../shared/use-viewer-roles'
import {useAuthorOrAssigneeDecider} from './Author'
import {useReviewerDecider} from './Reviewer'
import {useLifecycleDecider} from './Lifecycle'

export function useDecideNextAction() {
  const roles = useViewerRoles()
  const decideAuthorOrAssigneeAction = useAuthorOrAssigneeDecider()
  const decideReviewerAction = useReviewerDecider()
  const lifecycleAction = useLifecycleDecider()

  return decideNextAction({
    roles,
    authorOrAssigneeAction: decideAuthorOrAssigneeAction,
    reviewerAction: decideReviewerAction,
    lifecycleAction,
  })
}

// Data-agnostic function that can be used in tests to verify the correct action is selected for a given role.
export function decideNextAction({
  roles,
  authorOrAssigneeAction,
  reviewerAction,
  lifecycleAction,
}: {
  roles: ForYouViewerRoles
  authorOrAssigneeAction: ReactNode
  reviewerAction: ReactNode
  lifecycleAction: ReactNode
}): ReactNode {
  if (lifecycleAction !== null) {
    return lifecycleAction
  }

  if (roles.isAuthor || roles.isAssignee) {
    return authorOrAssigneeAction
  }

  if (roles.isReviewer) {
    return reviewerAction
  }

  return null
}
